import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartOptions,
  ChartData,
} from "chart.js";
import { FC, useMemo } from "react";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

interface ProgressBarProps {
  value: number;
  max?: number;
  height?: number;
  color?: string;
  trackColor?: string;
  showLabel?: boolean;
  animationDuration?: number;
  label?: string
}

const ProgressBar: FC<ProgressBarProps> = ({
  value,
  max = 100,
  height = 13,
  color = "#26890D",
  trackColor = "#e0e0e0",
  showLabel = true,
  animationDuration = 800,
  label: label
}) => {
  const safeValue = Math.min(Math.max(value, 0), max);
  const remaining = max - safeValue;

  const data: ChartData<"bar"> = useMemo(() => ({ 
    labels: ["Progress"],
    datasets: [
      {
        data: [safeValue],
        backgroundColor: color,
        borderRadius: 50,
        barThickness: height - 10,
      },
      {
        data: [remaining],
        backgroundColor: trackColor,
        borderRadius: 50,
        barThickness: height - 10,
      },
    ],
  }), [safeValue, remaining, color, trackColor, height]);

  const options: ChartOptions<"bar"> = useMemo(() => ({
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: true,
        min: 0,
        max: max,
        display: false,
      },
      y: {
        stacked: true,
        display: false,
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    animation: {
      duration: animationDuration,
    },
  }), [max, animationDuration]);

  return (
   <>
     <div style={{ height, position: "relative" }}>
      <Bar data={data} options={options} />
      
    </div>
    {showLabel && 
        <div className="text-[#BBBCBC] text-xs ">
            {label}
        </div>
    }
    
   </>
  );
};

export default ProgressBar;